import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

import CreateRentalAgreementHistoryForm from './Form'

export default function CreateRentalAgreementHistoryModal({
  close,
  isOpen,
  onSuccess,
  rentalId
}: {
  close: () => void
  isOpen: boolean
  onSuccess?: () => void
  rentalId: string
}) {
  return (
    <>
      <Modal toggle={close} isOpen={isOpen}>
        <ModalHeader toggle={close}>Create a Rental Agreement History</ModalHeader>
        <ModalBody>
          <CreateRentalAgreementHistoryForm
            onSubmit={close}
            onSuccess={onSuccess}
            rentalId={rentalId}
          />
        </ModalBody>
      </Modal>
    </>
  )
}
